<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("message.whatsappFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.broadcastMessagePerPrice") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.broadcastPerMessage" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.channelCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.channelCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.businessChannelCount") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.businessChannelCount" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("message.otherFeatures") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.bulkMessageSending">{{ $t("message.bulkMessageSending") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.messageUnregisteredNumbers">{{ $t("message.messageUnregisteredNumbers") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.personalizedBroadcastMessage"
                        >{{ $t("message.personalizedBroadcastMessage") }}
                    </a-checkbox>
                    <a-checkbox v-model="featureForm.whatsappChatbotEntegration">{{ $t("message.chatbotIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.controlWhatsapp">{{ $t("message.manageWhatsapp") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.notAdditionalPrice">{{ $t("message.noAdditionalCost") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.whatsappVoiceCalling">{{ $t("message.whatsappVoiceCalling") }}</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            channelCount: 0,
            businessChannelCount: 0,
            broadcastPerMessage: 0,
            bulkMessageSending: false,
            messageUnregisteredNumbers: false,
            personalizedBroadcastMessage: false,
            controlWhatsapp: false,
            whatsappChatbotEntegration: false,
            notAdditionalPrice: false,
            whatsappVoiceCalling: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.WHATSAPP);

            if (feature) {
                this.featureForm = {
                    channelCount: feature[Features.WHATSAPP.CHANNEL_COUNT] || 0,
                    businessChannelCount: feature[Features.WHATSAPP.BUSINESS_CHANNEL_COUNT] || 0,
                    broadcastPerMessage: feature[Features.WHATSAPP.BROADCAST_PER_MESSAGE] || 0,
                    bulkMessageSending: !!feature[Features.WHATSAPP.BULK_MESSAGE_SENDING],
                    messageUnregisteredNumbers: !!feature[Features.WHATSAPP.MESSAGE_UNREGISTERED_NUMBERS],
                    personalizedBroadcastMessage: !!feature[Features.WHATSAPP.PERSONALIZED_BROADCAST_MESSAGE],
                    controlWhatsapp: !!feature[Features.WHATSAPP.CONTROL_WHATSAPP],
                    whatsappChatbotEntegration: !!feature[Features.WHATSAPP.WHATSAPP_CHATBOT_ENTEGRATION],
                    notAdditionalPrice: !!feature[Features.WHATSAPP.NOT_ADDITIONAL_PRICE],
                    whatsappVoiceCalling: !!feature[Features.WHATSAPP.VOICE_CALLING],
                };
            }
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: "whatsapp", ...this.featureForm };
                response[Features.WHATSAPP.CHANNEL_COUNT] = +v.channelCount || 0;
                response[Features.WHATSAPP.BUSINESS_CHANNEL_COUNT] = +v.businessChannelCount || 0;
                response[Features.WHATSAPP.BROADCAST_PER_MESSAGE] = +v.broadcastPerMessage || 0;
                response[Features.WHATSAPP.BULK_MESSAGE_SENDING] = !!v.bulkMessageSending;
                response[Features.WHATSAPP.MESSAGE_UNREGISTERED_NUMBERS] = !!v.messageUnregisteredNumbers;
                response[Features.WHATSAPP.PERSONALIZED_BROADCAST_MESSAGE] = !!v.personalizedBroadcastMessage;
                response[Features.WHATSAPP.CONTROL_WHATSAPP] = !!v.controlWhatsapp;
                response[Features.WHATSAPP.WHATSAPP_CHATBOT_ENTEGRATION] = !!v.whatsappChatbotEntegration;
                response[Features.WHATSAPP.NOT_ADDITIONAL_PRICE] = !!v.notAdditionalPrice;
                response[Features.WHATSAPP.VOICE_CALLING] = !!v.whatsappVoiceCalling;
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.WHATSAPP);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
